import React, { useEffect, useReducer, useState } from 'react';
import TextInput from '../../components/Common/TextInput';
import CallOut from '../../components/Common/CallOut';
import Notification from '../../components/Common/Notification';
import { useTheme } from '../../DataStore/ThemeContext';
import { useSchool } from '../../DataStore/SchoolContext';
import { useVendor } from '../../DataStore/VendorContext';
import { useAccounts } from '../../DataStore/AccountsContext';
import ajaxSchool from '../../util/remote/ajaxSchool';
import VendorSelector from '../../components/Transaction/VendorSelector';

const initialState = {
    payee_id: '',
    discount_expense_account: '',
    discount_cash_account: '',
    manual_fees_entry_approval: '',
    api_key: '',
    student_src: '',
    class_src: '',
    residence_src: '',
    loading: false,
};

const reducer = (state, action) => {
    switch (action.type) {
        case "RESET":
            return { ...initialState };
        default:
            return { ...state, [action.type]: action.value };
    }
};

const ConfigFeesValue = ({ field }) => {
    const { setNotify, setSystemFunction, closeSettings } = useTheme();
    const { getConfig } = useSchool();
    const { getVendorListing } = useVendor();
    const { getExpenseAccounts, getPaymentAccounts, expenseAccountListing, paymentAccountListing, getLiabilityAccounts, liabilityAccountListing } = useAccounts();

    const [state, dispatch] = useReducer(reducer, initialState);
    const [info, setInfo] = useState(null);

    useEffect(() => {
        const fetchData = () => {
            switch (field.config_code) {
                case 'payee_id':
                    getVendorListing();
                    break;
                case 'discount_cash_account':
                    getPaymentAccounts();
                    break;
                case 'discount_expense_account':
                    getExpenseAccounts();
                    break;
                case 'deferred_payment_account':
                    getLiabilityAccounts();
                    break;
                case 'student_wallet_account':
                    getLiabilityAccounts();
                    break;
                default:
                    break;
            }
        };
        fetchData();
    }, [field]);

    useEffect(() => {
        if (info) {
            const timer = setTimeout(() => setInfo(null), 5000);
            return () => clearTimeout(timer);
        }
    }, [info]);

    useEffect(() => {
        setSystemFunction(() => handleSave);
        return () => setSystemFunction(() => { });
    }, [state]);

    const handleSave = async () => {
        if (state.loading) return;
        //ensure required fields are filled
        if (!state[field.config_code] || !state[field.config_code].value) {
            const errorNotification = <Notification type="danger" message="Please enter value, then try again." />;
            setInfo(errorNotification);
            return;
        }
        
        dispatch({ type: 'loading', value: true });

        const serverResponse = await ajaxSchool.setConfig(field.config_code, state[field.config_code].value || state[field.config_code]);
        dispatch({ type: 'loading', value: false });

        if (serverResponse.status === "OK") {
            const successNotification = <Notification type="success" message={serverResponse.message} />;
            setInfo(successNotification);
            setNotify(successNotification);
            setTimeout(() => getConfig(true), 2000);
            closeSettings();
        } else {
            setInfo(<Notification type="danger" message={serverResponse.message} />);
        }
    };

    const renderInputField = (type, label, placeholder, icon, valueKey) => (
        <TextInput
            type={type}
            label={label}
            placeholder={placeholder}
            leftIcon={icon}
            value={state[valueKey]}
            onChange={(e) => dispatch({ type: valueKey, value: e.target.value })}
            required
            wrap
        />
    );

    const RenderSelectInput = (label, placeholder, icon, list, refreshFn, actionType) => (
        <TextInput
            type="select"
            label={label}
            placeholder={placeholder}
            leftIcon={icon}
            options={(list || []).map((item) => ({
                label: `${item.account_number || ''} ${item.account_name || item.title || ''}`.trim(),
                value: item.account_id || item.payee_id,
            }))}
            onChange={(item) => dispatch({ type: actionType, value: item })}
            leftComponent={<i className={`fa ${icon} link`} onClick={refreshFn}></i>}
            loading={!list || list.length === 0}
            wrap
            value={state[actionType]}
        />
    );

    return (
        <>
            <CallOut title={field.config_name} description={field.description} />
            <div className='mt-4'>{info}</div>
            <form className="form-horizontal" onSubmit={handleSave}>
                {field.config_code === "payee_id" &&
                   
                    <VendorSelector 
                        onChange={(item) => dispatch({ type: "payee_id", value: item })} 
                        wrap label='Select Payee'
                        showCreate={false}
                        value={state.payee_id}
                        />
                }
                {field.config_code === "discount_cash_account" &&
                    RenderSelectInput(
                        "Discount Payment Track Account",
                        "Select payment track account...",
                        "fa fa-university",
                        paymentAccountListing,
                        () => getPaymentAccounts(true),
                        "discount_cash_account"
                    )}
                {field.config_code === "deferred_payment_account" &&
                    RenderSelectInput(
                        "Deferred Payment Account",
                        "Select deferred payment account...",
                        "fa fa-university",
                        liabilityAccountListing,
                        () => getLiabilityAccounts(true),
                        "deferred_payment_account"
                    )}

                {field.config_code === "student_wallet_account" &&
                    RenderSelectInput(
                        "Student Wallet Account",
                        "Select student wallet account...",
                        "fa fa-university",
                        liabilityAccountListing,
                        () => getLiabilityAccounts(true),
                        "student_wallet_account"
                )}

                {field.config_code === "discount_expense_account" &&
                    RenderSelectInput(
                        "Discount Expense Account",
                        "Select expense account...",
                        "fa fa-university",
                        expenseAccountListing,
                        () => getExpenseAccounts(true),
                        "discount_expense_account"
                    )}

                {field.config_code === "manual_fees_entry_approval" &&
                   <TextInput
                        type="select"
                        label="Approval status"
                        placeholder="Select approval status..."
                        leftIcon="fa fa-check-circle"
                        options={[
                            { label: 'Enabled', value: 'Enabled' },
                            { label: 'Disabled', value: 'Disabled' },
                        ]}
                        onChange={(item) => dispatch({ type: 'manual_fees_entry_approval', value: item })}
                        value={state.manual_fees_entry_approval}
                        wrap
                    />
                }
                          
                {field.config_code === "student_src" &&
                    renderInputField("text", "Students API", "https://", "fa fa-link", "student_src")}
                {field.config_code === "class_src" &&
                    renderInputField("text", "Classes API", "https://", "fa fa-link", "class_src")}
                {field.config_code === "residence_src" &&
                    renderInputField("text", "Residence API", "https://", "fa fa-link", "residence_src")}
                {field.config_code === "api_key" &&
                    renderInputField("textarea", "API Key/Access Token", "Enter token", "fa fa-key", "api_key")}

              
            
            </form>
        </>
    );
};

export default ConfigFeesValue;
